<script>
  // This component is used only by ReactiveAllGuas (which is called from ShowCompleteYaoInfo)
  export let numStr
  //export let question
  export let sectionName
  //export let isLogin

  //import { zhouyi } from "../etc/zhouyi.js"
  import GuaResult from "./GuaResult.svelte"
  import ShowGuaPic from "./ShowGuaPic.svelte"
  import ShowGuaText from "./ShowGuaText.svelte"
  import ShowYaoText from "./ShowYaoText.svelte"
  // import YangYao from "./YangYao.svelte"
  // import YinYao from "./YinYao.svelte"

  import { selectedLanguage } from "../etc/store.js"
  import {
    number2code,
    findGua,
    getGuaText,
    btn_style_yellow_d2,
    btn_style_blue_d2,
    btn_style_lime_d2,
    btn_style_orange_d2,
    btn_style_teal,
    btn_style_blue_d3,
  } from "../etc/helpers.js"

  //console.log("@GuaBriefing: got called from " + sectionName)

  $: gua_code = number2code(numStr)

  $: guaName = findGua(gua_code, $selectedLanguage)

  let guaText = {}
  let yao1 = ""
  let yao2 = ""
  let yao3 = ""
  let yao4 = ""
  let yao5 = ""
  let yao6 = ""
  let yaoXiang1 = ""
  let yaoXiang2 = ""
  let yaoXiang3 = ""
  let yaoXiang4 = ""
  let yaoXiang5 = ""
  let yaoXiang6 = ""
  let yaoPic1 = true
  let yaoPic2 = true
  let yaoPic3 = true
  let yaoPic4 = true
  let yaoPic5 = true
  let yaoPic6 = true

  $: if (gua_code != null) {
    guaText = getGuaText(gua_code, $selectedLanguage)
    gua_code[0] == 1 ? (yaoPic1 = true) : (yaoPic1 = false)
    gua_code[1] == 1 ? (yaoPic2 = true) : (yaoPic2 = false)
    gua_code[2] == 1 ? (yaoPic3 = true) : (yaoPic3 = false)
    gua_code[3] == 1 ? (yaoPic4 = true) : (yaoPic4 = false)
    gua_code[4] == 1 ? (yaoPic5 = true) : (yaoPic5 = false)
    gua_code[5] == 1 ? (yaoPic6 = true) : (yaoPic6 = false)
  }

  $: if (guaText != null) {
    yao1 = guaText.yao1
    yao2 = guaText.yao2
    yao3 = guaText.yao3
    yao4 = guaText.yao4
    yao5 = guaText.yao5
    yao6 = guaText.yao6

    yaoXiang1 = guaText.yaoXiang1
    yaoXiang2 = guaText.yaoXiang2
    yaoXiang3 = guaText.yaoXiang3
    yaoXiang4 = guaText.yaoXiang4
    yaoXiang5 = guaText.yaoXiang5
    yaoXiang6 = guaText.yaoXiang6
  }

  let showSummary = true
  let showDetails = false
  let showWholeView = false

  function getParameterByName(name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, "\\$&")
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ""
    return decodeURIComponent(results[2].replace(/\+/g, " "))
  }

  //   console.log("@ GuaBriefing: Got question: " + question)
  //   console.log("@ GuaBriefing: Got numStr: " + numStr)

  function showYiOptions() {
    let x = document.getElementById("top-to-hide")
    x.style.display = "block"

    let y = document.getElementById("showgua")
    y.style.display = "none"

    //console.log("@ GuaBriefing: guaName is " + guaName)

    // Reset view back to summary
    showView("")

    // Auto scroll back to the top of the page
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }

  function showView(view) {
    showSummary = false
    showDetails = false
    showWholeView = false

    //console.log("@ GuaBriefing: showView option: " + view)

    if (view == "details") {
      showDetails = true
    } else if (view == "whole") {
      showWholeView = true
    } else {
      showSummary = true
    }
  }

  let upGua = ""
  let downGua = ""
  function getUpDownGuaName(guaName) {
    upGua = guaName[0]
    if (guaName[1] == "為") {
      downGua = upGua
    } else {
      downGua = guaName[1]
    }
  }

  $: getUpDownGuaName(guaName)
</script>

<!-- Gua Summary Section Begin -->
<div class="gua-summary" style="display:{showSummary ? 'block' : 'none'}">
  <div class="card indigo lighten-5">
    <div class="card-body gua-results">
      <div class="gua-header">
        <h4>
          {guaName}
        </h4>
        <!-- {#if sectionName == "qi"}
          <h5>問：{question}</h5>
        {/if} -->
      </div>
      <!-- <hr /> -->
      <div class="gua-info">
        <div class="gua-level">
          <div class="gua-pic "><ShowGuaPic {numStr} {gua_code} /></div>
          <div class="gua-text green lighten-5">
            <ShowGuaText {numStr} {gua_code} />
          </div>
        </div>
        <div class="yao-level blue lighten-4">
          <ShowYaoText {numStr} {gua_code} />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Gua Summary Section End -->
<style>
  h4 {
    padding-left: 10px;
    padding-top: 10px;
  }
  .gua-level {
    display: grid;
    grid-template-columns: 1fr 4fr;
    min-height: 100px;
    padding-bottom: 10px;
  }
  .yao-level {
    width: 100%;
    min-height: 200px;
  }
  .gua-pic {
    margin: auto;
    /* justify-content: center; */
  }
  .gua-header h4 {
    padding-bottom: 15px;
    min-height: 50px;
  }
  .btn-single {
    margin-right: 10px;
  }
  .d-detail-view {
    display: grid;
    grid-template-columns: 1fr;
  }
  .gua-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr 7fr;
  }
  .yao-t {
    display: grid;
    grid-template-columns: 1fr;
  }
  .member-only {
    height: 100px;
  }
</style>
